import { cardRef, defineGameCard, onResolve, planningTargets, targetStep, unitTarget, } from '../authoring/index.js';
import { committedUnitTarget } from './furniture_helpers.js';
export const GrandmasBlanketCard = defineGameCard({
    id: 'grandmas_blanket',
    gameplay: {
        type: 'SPELL',
        cost: 3,
        planning: planningTargets([
            targetStep('target', unitTarget({
                side: 'any',
                cardTypes: ['UNIT', 'STRUCTURE'],
                cardinality: { min: 1, max: 1 },
            })),
        ]),
    },
    presentation: {
        name: 'Бабушкин плед',
        description: 'Дайте выбранной карте +2 к атаке и восстановите ей 2 здоровья.',
        glyph: {
            colors: ['#10213A', '#D88C49', '#656B6D', '#BA4835', '#EEBF72'],
            rows: [
                '....................',
                '...11111111111111111',
                '...12233444555551111',
                '...12333344455511111',
                '..122333444545511111',
                '..133344555111122221',
                '.1333444555111112221',
                '.1333334445511112221',
                '.1444445511122333331',
                '.144455551112233331.',
                '1444555511222223331.',
                '1551111222333444441.',
                '155111122333334441..',
                '155512222333344441..',
                '111122233344445551..',
                '11111223333444551...',
                '11112222333444451...',
                '11111111111111111...',
                '1.11.1.1111.111.1...',
                '1.1.1..1..11.1.1....',
            ],
        },
    },
    role: 'playable',
    dependencies: [cardRef('grandmas_blanket')],
    abilities: [
        onResolve((ctx) => {
            const targetId = committedUnitTarget(ctx);
            const target = targetId === undefined ? null : ctx.q.instance(targetId);
            const targetType = target === null ? undefined : ctx.q.cardType(target.id);
            if (ctx.self === undefined || target?.zone !== 'board' || target.cellId === undefined
                || (targetType !== 'UNIT' && targetType !== 'STRUCTURE'))
                return;
            ctx.ops.addEffect({
                defId: GrandmasBlanketCard.id,
                scope: { kind: 'unit', instanceId: target.id },
                sourceId: ctx.self.id,
                persistent: true,
                statMods: [{ stat: 'attack', op: 'add', value: 2 }],
            });
            ctx.ops.restoreUnitHealth(target.id, 2, ctx.self.id);
        }),
    ],
    ui: {
        planning: {
            steps: { target: { label: 'Выберите карту' } },
        },
    },
});
//# sourceMappingURL=grandmas_blanket.js.map